/**
 *Created by jmmartinez on 04/12/23
 */

import React from "react";
import {filtrarConNombreCampo, buscarConNombreCampo} from "./FilterUtils";
import {getSession} from "./SessionUtils";

class ComponentsManager {

    constructor(elementoConfig) {
        if (elementoConfig)
            this.components = this.generarComponents(elementoConfig);
        else
            this.components= [];
    }

    generarComponents= (elementoConfig) => {
        //console.log("generarTabOrders");
        let components = [];
        elementoConfig.campos.forEach( (campo, index) => {
            components.push({
                campoNombre: campo.campo,
                ref: React.createRef()
            })
        });
        return components;
    }




    getComponentPorCampoNombre= (campoNombre) => {
        let componenteBuscado= null;
        this.components.forEach((componente, index) => {
            if (componente.campoNombre == campoNombre)
                componenteBuscado= componente;
        });
        return componenteBuscado;
    }

    getRef= (campoNombre) => {
        //console.log("GETREF----->", campoNombre);
        let componente= this.getComponentPorCampoNombre(campoNombre);
        //console.log("componente: ", componente);
        if (componente)
            return componente.ref;
        else
            return null;
    }

    procesarComponents= () => {
        //console.log("COMPONENTSMANAGER PROCESARCOMPONETS")
        this.components.forEach( (component) => {
            //console.log("component:". component);
            if (component.ref.current)
               component.ref.current.callOnChange();
        });
    }

    log= () => {
        console.log("LOG ComponentsManager");
        this.components.forEach( (component) => {
            console.log("campo: ", component.campoNombre);
            console.log("ref: ", component.ref)
      });
    }

}

export default ComponentsManager;